export enum CalendarViewEnum {
  table = "table",
  calendar = "calendar",
}
